import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Observable, Subscription } from 'rxjs';
import {
  ManagedContentServerData,
  Workflow,
} from '../../../../core/models/fna';
import { startWith, switchMap } from 'rxjs/operators';
import { ApiService } from '../../../../core/services/api-mock.service';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
} from '../../../../core/models/common';
import {
  AccreditedInvestorData,
  AccreditedInvestorRequestData,
} from '../accredited-investor/accredited-investor.component';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SharedAPIService } from '../../../../core/services/shared-api.service';

// What we receive from the API when page is loaded
export interface ConfirmationData extends ResponseBase {
  FNAConfirmationStatus: string;
  DocuSignURL: string;
}

// What we will send to the API when submit
export interface ConfirmationRequestData extends PostRequestBase {}

// What we work with in this screen.
export class ConfirmationModel extends ScreenModel {
  screenName = 'Confirmation';
  data: ConfirmationData | undefined;
  status: string | null = null;
  docuSignURL: string | null = null;

  // Data lifecycle start.

  deriveFromData(data: ConfirmationData) {
    this.status = data.FNAConfirmationStatus;
    this.docuSignURL = data.DocuSignURL;
    console.log('deriveFromData, model:', this);
  }
}

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  model = new ConfirmationModel(this.globals, this.apiService, this.el);

  // 3 states for Docusign status
  // 'Success'
  // OR
  // 'Pending'
  // OR
  // 'Failed'
  status: string = '';
  docuSignURL: string|null = '';

  constructor(
    private apiService: ApiService,
    public globals: GlobalsService,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService,
  ) {}

  async ngOnInit() {
    console.log('[ConfirmationComponent.OnInit]');
   // await this.model.loadData();
    this.status = this.sharedAPIService.getDocusignStatus();
    this.docuSignURL = this.sharedAPIService.getDocusignURL();
  }

  handleGoToReSignDocument() {
    if (this.docuSignURL) {
      this.sharedAPIService.setDocusignClicked('yes')
      window.location.href = this.docuSignURL;
    }
  }
}
